import { computed, ref, watch, type Ref } from "vue";

export function useSidebarFavorites(userKey: Ref<string>) {
  const favorites = ref<string[]>([]);
  const storageKey = computed(() => `favorites:${userKey.value}`);
  watch(storageKey, (key) => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || "[]");
      favorites.value = Array.isArray(stored)
        ? [...new Set(stored.filter((path): path is string => typeof path === "string" && path.length > 0))]
        : [];
    } catch { favorites.value = []; }
  }, { immediate: true, flush: "sync" });

  function save(paths: string[]) {
    favorites.value = paths;
    try { localStorage.setItem(storageKey.value, JSON.stringify(paths)); } catch { /* Keep favorites usable if browser storage is unavailable. */ }
  }
  function addFavorite(path: string) {
    if (!favorites.value.includes(path)) save([...favorites.value, path]);
  }
  function removeFavorite(path: string) {
    save(favorites.value.filter((favorite) => favorite !== path));
  }
  function moveFavorite(path: string, beforePath?: string) {
    if (path === beforePath) return;
    const paths = favorites.value.filter((favorite) => favorite !== path);
    const index = beforePath ? paths.indexOf(beforePath) : -1;
    paths.splice(index < 0 ? paths.length : index, 0, path);
    save(paths);
  }
  return { favorites, addFavorite, removeFavorite, moveFavorite };
}
